﻿import { FIQAssist  } from "../app";
import { Component, Input, Output, Attribute, Inject } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'radiobar',
    transclude: true,
    template: `<div class="radiobarframe ng-class:{readonly:$ctrl.readOnly}" tabindex="0" ng-keydown="$ctrl.onKey($event)"><div class="radiobar"></div></div>`
})
export class RadioBar {
    private _element: angular.IRootElementService;
    private _transclude: angular.ITranscludeFunction;

    private _readOnly:boolean;
    @Input() public get readOnly(){
        return this._readOnly;
    }
    public set readOnly(readOnly:boolean){
        this._readOnly = readOnly;
        if(this._options)
            this.options.forEach(o=>o.readOnly = this.readOnly);
    }

    constructor(
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$transclude') $transclude: angular.ITranscludeFunction
    ) {
        this._element = $element;
        this._transclude = $transclude;
        this.initTransclude(this._transclude, this._element);
    }

    initTransclude(transclude: angular.ITranscludeFunction, element: angular.IRootElementService) {
        transclude((e, s) =>
            element.children().children().append(e));
    }

    public addOption(option: BarOption): (sender: BarOption, value: boolean) => void {
        this.options = this.options.concat(option);
        option.readOnly = this.readOnly;
        return (s, v) => {
            if (v) {
                this.options.filter(o => o != s).forEach(o => o.active = false);
                this.checkActive();
            }
        };
    }

    @Output() public onoptionchanged: (args: { value: any, text: string }) => void;


    public get options(): BarOption[] {
        return this._options || [];
    }

    public set options(value: BarOption[]) {
        this._options = value;
        if (value && value.length > 0 && value.filter(o => o.active).length > 1) {
            value.filter(o => o.active).slice(1).forEach(o => o.active = false);
        }
        this.checkActive();
    }

    @Input()
    public get value() {
        return this._activeOption ? this._activeOption.value : undefined;
    }
    public set value(val) {
        if (val !== undefined) {
            var o = this.options.filter(op => op.value == val);
            if (o.length === 1) {
                o[0].active = true;
                if (this._activeOption !== o[0])
                    this._activeOption = o[0];
            }
        }
    }

    private _options;

    private _activeOption: BarOption;

    private checkActive() {
        var a = this.options.filter(v => v.active).pop();
        if (a !== this._activeOption) {
            this._activeOption = a;
            var value = a ? a.value : null;
            var text = a ? a.text : null;
            this.onoptionchanged({ value: value, text: text });
        }
    }

    private onKey($event: KeyboardEvent) {
        if(this.readOnly)
            return;

        switch ($event.keyCode) {
            case 37:
            case 38:
                this.move(-1);
                break;

            case 39:
            case 40:
                this.move(1);
                break;
        }
    }

    private move(direction: number) {
        if (this.options.length > 0) {
            var newindex = Math.max(0, Math.min(this.options.length - 1, this.options.indexOf(this._activeOption) + direction));
            if (!this.options[newindex].notallowed) {
                this.value = this.options[newindex].value;
                this.onoptionchanged({ value: this.value, text: this.options[newindex].text });
            }
        }
    }

}

@Component({
    module: FIQAssist,
    selector: "radiobaroption",
    controllerAs: "baroption",
    require: {
        radioBar: "^radiobar"
    },
    template: `<div class="radiobaroption {{baroption.value}} ng-class:{readonly:baroption.readOnly, notallowed:baroption.notallowed}" ng-click="baroption.click()">
                    <div class="textpart">{{baroption.text}}</div>
                    <div class="imgpart">
                        <div class="tooltip-div"
                            tooltip-popup-delay="200"
                            uib-tooltip="{{baroption.hint}}"
                            tooltip-placement="bottom"
                            tooltip-class="customTooltipTB"
                            tooltip-popup-close-delay="500">
                            <div ng-hide="baroption.notallowed" class="knob {{baroption.activecolor}} ng-class:{active:baroption.active}"></div>
                        </div>
                    </div>
                </div>`
})

export class BarOption {
    @Input() public readOnly:boolean;
    constructor(
        @Inject('$scope') $scope
        ) {
        this.activecolor = this.activecolor || "grey";
    }

    private click(){
        if(!this.readOnly)
            this.active = true && !this.notallowed;
    }

    private _radioBar: RadioBar;
    public get radioBar() {
        return this._radioBar;
    }

    public set radioBar(b: RadioBar) {
        this._radioBar = b;
    }

    public $onInit() {
        if (this._radioBar)
            this.activeChanged = this._radioBar.addOption(this);

        if(!this.hint)
            this.hint = ''; // this.text
    }

    private activeChanged: (sender: BarOption, value: boolean) => void;
    private onActiveChanged() {
        if (this.activeChanged)
            this.activeChanged(this, this.active);
    }
    private _active: boolean;

    @Input()
    public get active(): boolean {
        return !!this._active;
    }
    public set active(value) {
        if (value !== undefined) {
            var a = this.active;
            this._active = (<any>value === "false" ? false : !!value);
            if (this.active !== a)
                this.onActiveChanged();
        }
    }

    @Input() public value: any;
    @Input() public text: string;
    @Input() public hint: string;
    @Attribute() public labelbehind: boolean;
    @Input() public notallowed: boolean;
    @Input() public activecolor: string;
}
